import { graphql, useStaticQuery } from "gatsby";

// The ACF field group lives on the "Theme Settings" options page and is
// exported as `popup_settings` (see acf/popup-settings.json).
const usePopupSettings = () => {
  const data = useStaticQuery(graphql`
    query PopupSettingsQuery {
      wp {
        themeSettings {
          popup_settings {
            general {
              popupsEnabled
              showFrequency
              independentPopups
              reopenAfterMinutes
              excludedPaths
            }
            exitIntentPopup {
              enabled
              enableOnMobile
              armAfterSeconds
              eyebrow
              subtitle
              title
              note
              noteHighlight
              description
              formId
              submitLabel
              successMessage
              promoTitle
              promoSubtitle
              promoSubtitleHighlight
              promoBackgroundColor
              promoLogo {
                altText
                sourceUrl
              }
              promoImage {
                altText
                sourceUrl
              }
              promoLink {
                url
                title
                target
              }
            }
            inactivityPopup {
              enabled
              enableOnMobile
              inactivitySeconds
              requirePriorInteraction
              pauseWhenVideoPlaying
              eyebrow
              subtitle
              title
              note
              noteHighlight
              description
              formId
              submitLabel
              successMessage
              promoTitle
              promoSubtitle
              promoSubtitleHighlight
              promoBackgroundColor
              promoLogo {
                altText
                sourceUrl
              }
              promoImage {
                altText
                sourceUrl
              }
              promoLink {
                url
                title
                target
              }
            }
          }
        }
      }
    }
  `);

  return data?.wp?.themeSettings?.popup_settings || null;
};

export default usePopupSettings;
